<template>
  <div class="gate-reward">
    <dropdown
      :options="rewardTypes"
      :selected="currentType"
      label="Reward type"
      @on-change="onTypeChange"/>
    <b-input
      v-if="currentType.value === 'link'"
      :value="link"
      @input="$emit('update:link', $event)"
      :show-validate-icons="true"
      :error="this.$v.link.$error"
      :v="this.$v.link"
      :min="4"
      :req="true"
      :max="1024"
      :show-counter="false"
      label="Enter URL link to your offer">
<!--      <template  #tooltip>-->
<!--        <vue-custom-tooltip label="Link to download content" position="is-right" abbreviation>-->
<!--          <i style="color: #666; margin-left: 8px" class="fak fa-circle-info-light"/>-->
<!--        </vue-custom-tooltip>-->
<!--      </template>-->
    </b-input>
    <b-input
      v-if="currentType.value === 'coupon_code'"
      :value="coupon_code"
      :max="32"
      @input="$emit('update:coupon_code', $event)"
      :show-validate-icons="true"
      :error="this.$v.coupon_code.$error"
      :v="this.$v.coupon_code"
      :req="true"
      label="Enter your coupon code">
<!--      <template  #tooltip>-->
<!--        <vue-custom-tooltip label="Coupon code" position="is-right" abbreviation>-->
<!--          <i style="color: #666; margin-left: 8px" class="fak fa-circle-info-light"/>-->
<!--        </vue-custom-tooltip>-->
<!--      </template>-->
    </b-input>
    <gate-file-uploader
      ref="gateFileUploader"
      v-if="currentType.value === 'file'"
      :file="file"
      @reward-file-set="$emit('reward-file-set', $event)"
      :file_from_server="file_from_server"
      @on-delete="file = []"
      @on-delete-from-server="$emit('on-delete-from-server')"
      @on-upload="file=$event"/>
    <gate-image-uploader
      ref="gateImageUploader"
      @is-set-image="$emit('is-set-image', $event)"
      @reward-image-set="$emit('reward-image-set', $event)"
      v-if="currentType.value === 'image'"
      :image="image"
      @on-upload="image=$event"/>
    <b-input
      :value="description || ''"
      @input="$emit('update:description', $event)"
      label="Reward description"
      :max="250"
      inp-type="textarea"/>
  </div>
</template>
<script>
import Vue from 'vue'
import Dropdown from "@/components/__new_ui_kit/Dropdown/Dropdown";
import BInput from "@/components/__new_ui_kit/Input/BInput";
import {required} from "vuelidate/lib/validators";
import {isValidUrl} from "@/utils/validations/isUrlValid";
import GateFileUploader from "@/components/GateReward/GateFileUploader";
import GateImageUploader from "@/components/GateReward/GateImageUploader";
import { isCouponCodeValid } from "../../utils/validations/isCouponCodeValid";
import {minMaxLength} from "../../utils/validations/minMaxLength";
export default Vue.extend({
  components: {
    GateImageUploader,
    BInput,
    Dropdown,
    GateFileUploader,
  },
  props: {
    link: {},
    reward_type: {},
    image_prop: null,
    description: {},
    coupon_code: {},
    file_from_server: ''
  },
  data() {
    return {
      rewardTypes: [
        {value: 'link', label: 'Link'},
        {value: 'coupon_code', label: 'Coupon code'},
        {value: 'file', label: 'Downloadable file'},
        {value: 'image', label: 'Image'}
      ],
      currentType: {value: 'link', label: 'Link'},
      file: [],
      image: [],
    }
  },
  validations() {
    switch (this.currentType.value) {
      case "link": return {
        link: {
          required,
          isValidUrl: isValidUrl(true)
        }
      }
      case "coupon_code": return {
        coupon_code: {
          required,
          minMaxLength: minMaxLength(4, 32),
          isCouponCodeValid: isCouponCodeValid()
        }
      }
      case "file": return {
        file: {
          required,
        }
      }
      case "image": return {
        image: {
          required,
        }
      }
    }
  },
  computed: {
    info() {
      return this.file.length ? this.file[0] : null
    },
    valueSize () {
      if (!!this.info) {
        const mb = this.info.size / 1000000
        return mb.toFixed(1)
      }
      return 0
    }
  },
  mounted() {
    if (this.$route.params?.id) {
      this.$v.$touch()
    }
    this.currentType = this.rewardTypes.find(v => v.value === this.reward_type)
    this.image = this.image_prop
  },
  methods: {
    // fixme прошлое состояние остается (file, coupon_code, link, image), возможно надо стирать его...
    onTypeChange(value) {
      this.currentType = value
      // this.$v.$touch()
    }
  },
  watch: {
    '$v.$invalid'(value) {
      this.$emit('error-handle', 'gate-reward', value)
    },
    currentType(v) {
      this.$emit('change-reward-type', v.value)
    },
    valueSize(v) {
      this.$emit('change-file-size', v)
    }
  }
})
</script>
<style lang="scss" scoped>;
.gate-reward {
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>